var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBateonBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 141.73 141.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#010101;}.cls-2{fill:url(#Degradado_sin_nombre_2);}.cls-3{fill:#e4ae5f;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    x1: 21.32,
    y1: -2120.14,
    x2: 120.84,
    y2: -2177.6,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -2078.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6bc68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#846236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb9b55"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bateonBox") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 141.73,
    height: 141.73,
    rx: 34.98
  }), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2-2",
    "data-name": "Capa 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.31,37.8A57,57,0,0,0,70.88,12.61C47.14,12.76,31.8,28.16,30.07,30c-15.24,15.79-16,35-15.89,41.13a59.32,59.32,0,0,0,11.1,33.73C27.62,108,43.38,129,71,129.12c1.74,0,27.34-.27,44.19-21.33C127.08,93,127.49,76.65,127.55,71.08,127.62,65.78,127.59,51.8,118.31,37.8ZM105,113.65c-18.2,14.19-38.76,11-43.7,10.15-5.1-.88-18.16-3.31-29.18-14.54C17.53,94.34,17.78,75.41,17.88,72,18.5,51.8,31,39.15,34.54,35.6c2.73-2.69,20.19-19.35,44.35-16.27,25.59,3.25,46.77,27.15,46.74,53.29C125.6,97.14,106.94,112.18,105,113.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110,70.77a21.91,21.91,0,0,0-4.24-8.32,15,15,0,0,0-1.64-1.55l-.38-.37c-.14-.14-.27-.27-.41-.39a5.59,5.59,0,0,0-.61-.48c-.29-.21-.95-.72-2.47-2a82,82,0,0,1-21.84,5A82.89,82.89,0,0,1,44.8,58.64a52.69,52.69,0,0,0,5.5-6.07,34.56,34.56,0,0,0,4.88-7.72,33.48,33.48,0,0,0,2.6-12.14,11.49,11.49,0,0,0,0-2.22,9.54,9.54,0,0,0-.49,2A53,53,0,0,1,55,40.23C52.39,47.29,45.58,53,44.73,53.75,42.44,55.64,41,56.37,38.56,59a37.7,37.7,0,0,0-4.17,5.56c-1.9,2.87-3.39,6.31-3.55,8.12,0,.1-.1.82-.18,1.75,0,.52-.08,1-.12,1.65a18.73,18.73,0,0,0-.08,2,36,36,0,0,0,.78,7.4,23.72,23.72,0,0,0,2.82,6.39,24.68,24.68,0,0,0,13.47,9.87,21.69,21.69,0,0,0,12.34.26,15.88,15.88,0,0,0,4.87-2.25A16.36,16.36,0,0,0,71,90a15,15,0,0,0,11.78,12.24A20.27,20.27,0,0,0,93.4,102a21,21,0,0,0,8.84-4.42,21.53,21.53,0,0,0,5.5-7.77,29.47,29.47,0,0,0,2.57-10.23A24.55,24.55,0,0,0,110,70.77ZM70.46,88.66A5.74,5.74,0,0,1,70,89.78a8.27,8.27,0,0,1-.46.69c-.16.21-.29.36-.34.44a37.82,37.82,0,0,1-3,3.45,14.73,14.73,0,0,1-5.1,3.4,15.63,15.63,0,0,1-5.16.88,22.9,22.9,0,0,1-5-.28,19.29,19.29,0,0,1-15.19-13c-1.39-4.51-.62-8.54-.1-11.32a24.56,24.56,0,0,1,.62-2.53,25.51,25.51,0,0,1,6.09-10.33,49.27,49.27,0,0,1,10.1,3.42C56,66.23,62,69,65.94,74.59a29.75,29.75,0,0,1,2.89,5.32c.25.62.66,2.12,1.47,5.13a7.77,7.77,0,0,1,.16,3.65Zm37.76-10.57a25.12,25.12,0,0,1-.93,5.71,23.92,23.92,0,0,1-3,6.35,20.47,20.47,0,0,1-5.8,6.07,19.16,19.16,0,0,1-7.14,3,18.4,18.4,0,0,1-7.85-.23A22.18,22.18,0,0,1,75,94.45a12.6,12.6,0,0,1-.9-.89,14,14,0,0,1-1.85-2.41,7.27,7.27,0,0,1-.77-3.75c.07-5.25,4.61-10.89,7-13.77a30.83,30.83,0,0,1,3.34-3.7,32.89,32.89,0,0,1,9.93-6.21c1.76-.72,4.15-1.48,5.77-2,2.1-.68,3.86-1.19,5.1-1.55a20.36,20.36,0,0,1,3.59,5.23A22.57,22.57,0,0,1,108.05,72a27.57,27.57,0,0,1,.17,6.09Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBateonBox);
export default __webpack_public_path__ + "static/media/bateonBox.23bf92f5.svg";
export { ForwardRef as ReactComponent };